<template>
	<div>
		<el-container>
	  		<el-header style="height: auto;">
	  			<Top/>
	  		</el-header>
	  		<el-main :style="{minHeight:$store.state.minHeight}">
	  			<router-view/>
	  		</el-main>
	  		<el-footer style="height: auto;" v-if="isShowFooter">
	  			<Footer></Footer>
	  		</el-footer>
		</el-container>
		<Login/>
		<Register/>
		<Forgotpass/>
		<ShopCartBox/>
	</div>
</template>

<script>
	import Top from '@/common/Top.vue'
	import Footer from '@/common/Footer.vue'
	import Login from '@/common/Login.vue'
	import Register from '@/common/Register.vue'
	import Forgotpass from '@/common/ForgotPass.vue'
	import ShopCartBox from '@/common/ShopCartBox.vue'
export default {
	components: {
        Top,
		Footer,
		Login,
		Register,
		Forgotpass,
    ShopCartBox
    },
	data () {
		return {
			isShowFooter: false,
		}
	},
	mounted(){
		this.isShowFooter = window.location.href.indexOf('wennoanimal.com')!= -1 ? true : false;
		var that = this;
		window.addEventListener('resize',()=>{
			// console.log('width: '+document.body.clientWidth);
            var val = $(document.body).width()>=768?true:false;
            that.$store.commit('setIsPC',val);
            that.$store.commit('setMinHeight',($(window).height()-140)+'px');
            document.body.style.overflow='';
        })
	},
	methods:{

	},
}
</script>
<style scoped>
	.el-header,.el-main,.el-footer{
		margin: 0;
		padding: 0;
	}
	.el-main{
		width: 100%;
		margin: auto;
	}
</style>



// WEBPACK FOOTER //
// src/newpage/NewHome.vue